import UserPreferences from '../../api/userPreferences';
import { getUserSettings } from '../../actions/userPreferences';
import Bugsnag from '../../bugsnag';

export default (dispatch, { name, value }) => {
    UserPreferences.updateUserSettings({ name, value })
        .then(() => { dispatch(getUserSettings()); })
        .catch(error => Bugsnag.notify(error));
};
